import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// ====================================================================
// ziven-custom-tags — forum entry
// ====================================================================
//
// v0.1.0 范围 (Trello #397 任务 C, 辉哥 2026-07-31 拍板):
//   - TagsPage tagTileView extend: 把 tag.attribute('bgImageUrl') 注入
//     li style 的 --tag-bg-image CSS 变量, 让 forum.less 背景图样式生效
//   - fallback: 没 bgImageUrl 的 tag 走 vendor 默认 (背景色 var(--tag-bg))
//
// v0.1.0l 范围 (辉哥 2026-08-01 00:40 反馈):
//   - 帖子列表页 TagHero header 也要支持背景图
//   - TagHero.prototype.style override: 注入 --hero-bg-image CSS 变量
//   - TagHero.prototype.className override: 注入 ziven-custom-tags-header-has-bg-image className
//     (forum.less 用这个 className 触发 60% 黑遮罩)
//
// v0.1.0m 范围 (辉哥 2026-09-09 09:09 反馈, 改打):
//   - 帖子列表页 + 详情页 hero: 如果 tag 有 bgImageUrl, 把 tagLabel 里的 FA 图标
//     替换成 <img>, 图片长宽跟 vendor FA Button-icon (14px) / vendor TagIcon
//     占位框 (16x16) 一致 (16x16) — 保留 .TagLabel-icon className 让 vendor 样式继续生效
//   - 实现: extend(DiscussionListItem.prototype, 'infoItems') + extend(DiscussionHero.prototype, 'items')
//     替换 vendor 'tags' item, 用 CustomTagsLabel 组件渲染 (遍历 tags + bgImageUrl 走 img 替换)
//   - 触发条件: 任何一个 tag 有 bgImageUrl 才替换整个 tags 区域, 没图标的走原 vendor tagLabel
//   - forum.less 加 img.ziven-custom-tags-label-image 强制 16x16 + 圆角 + object-fit: cover
//   - 没 bgImageUrl 的 tag 走 vendor 默认 FA 图标, 完全不变
//
// v0.1.0n 范围 (辉哥 2026-09-09 12:01 反馈, 改打):
//   - 后台加新字段 tag_icon_url (跟 bg_image_url, header_bg_image_url 独立)
//   - 用途: 帖子列表 + 详情页 hero tag 显示的方形小图标 (15x15)
//   - 优先级: tagIconUrl > vendor FA icon (无 bgImageUrl fallback, 见 v0.1.0n.a)
//
// v0.1.0n.a 改 (辉哥 2026-09-09 12:14 反馈 "前台还是用帖子背景图, 而不是新加的tag图片图标"):
//   - 替换判断从 bgImageUrl 改成 tagIconUrl — 任何 tag 有 tagIconUrl 才整段替换 vendor tags item
//   - 内部 CustomTagsLabel 也去掉 bgImageUrl fallback — 9/9 配的科普知识 tag (有 bgImageUrl 没 tagIconUrl)
//     不再触发 CustomTagsLabel 替换, 走 vendor 原生 tagsLabel (FA icon)
//   - 现在: 配 tagIconUrl → 15x15 图; 没配 → vendor 原生 FA icon (兜底, 不再用 bgImageUrl 介入帖子列表)
//
// v0.1.0m.b 撤回 (重要): 之前误改 TagLinkButton.linkItems, 但 Flarum 2.0 列表页
//   tag 渲染走 vendor tags 扩展 extend(DiscussionListItem.prototype, 'infoItems', ...)
//   加 'tags' item 调 tagsLabel() helper, 内部用 tagLabel() helper 渲染, 不是 TagLinkButton.
//   TagLinkButton 只在 sidebar / index navItems 用, 列表页 DiscussionListItem 走的是
//   .TagLabel 元素 (用 .tag-label() mixin, 圆角 + 背景色), 不是 .TagLinkButton 元素.
//   撤回 TagLinkButton.linkItems 改动, 改 extend DiscussionListItem.infoItems +
//   extend DiscussionHero.items 替换 tags item 为 CustomTagsLabel mithril component.
//
// 跟 ziven-dress-up forum 同款 2.0 pattern (辉哥 2026-07-20 21:38 拍板砍 1.8 兼容).
//
// 技术细节 (重要):
//   - Flarum 2.0 extend() wrap 是先调 original, 再调 callback, 然后返回 original.
//     所以 callback 拿到的 vnode 是 original 创建的, 可直接 mutate vnode.attrs.style
//     加 --tag-bg-image 字段. mithril 渲染时会看到新 style.
//   - extend() callback 不能改返回值, 只能 mutate (所以走 mutating 时用 extend).
//   - override() 是 replacement function, 接管原 method. 适合需要改 return 的场景
//     (如 TagHero.style() 返回 object, override 改 object 加新字段).
//   - Tag model attribute: 走 `this.tag.attribute('bgImageUrl')` 直接读 (Flarum 2.0
//     Model 通用 accessor, 不需要 extend Tag.prototype, 因为 extend() wrap 返回
//     original 值, callback return 会被丢弃).
//   - v0.1.0m: ItemList.add() 同 key 已存在会跳过, 所以用 items.remove('tags') 后
//     items.add('tags', m(CustomTagsLabel, {tags}), 10) 替换 vendor tags item.
//   - mithril 渲染生命周期: ziven-custom-tags extend 先在 mithril vnode 阶段改了
//     'tags' item 为 CustomTagsLabel, ziven-core mobile jQuery 重组 onupdate 阶段
//     clone 改后的 DOM 到 itemFooter, 自动继承新版本 (不需要双改).
// ====================================================================

import { extend, override } from 'flarum/common/extend';
import app from 'flarum/common/app';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
import TagHero from 'ext:flarum/tags/forum/components/TagHero';
import TagLinkButton from 'ext:flarum/tags/forum/components/TagLinkButton';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import tagIcon from 'ext:flarum/tags/common/helpers/tagIcon';
import CustomTagsLabel from './components/CustomTagsLabel';

// 共享: 渲染单个 tag 的 icon 部分 (有 tagIconUrl 走 15x15 wrap, 没走 vendor FA)
// 用于 TagHero.contentItems 'tag-title' + TagLinkButton.linkItems 'icon'
// DiscussionListItem.infoItems + DiscussionHero.items 走 CustomTagsLabel 整段替换 (多个 tag)
// iconClassName: 调 vendor tagIcon 时的 className, 跟使用场景匹配
//   - 'TagLabel-icon' (DiscussionListItem / DiscussionHero / TagHero 跟文字并排)
//   - 'Button-icon' (TagLinkButton sidebar 按钮内, 跟 vendor TagLinkButton 一致)
function renderTagIconPart(tag, iconClassName) {
  if (iconClassName === void 0) {
    iconClassName = 'TagLabel-icon';
  }
  if (!tag) return null;
  const tagIconUrl = tag.attribute && tag.attribute('tagIconUrl');
  if (tagIconUrl) {
    return m("span", {
      className: "ziven-custom-tags-label-wrap",
      style: {
        backgroundImage: "url(".concat(tagIconUrl, ")")
      },
      role: "img",
      "aria-label": tag.name()
    });
  }
  if (tag.icon && tag.icon()) {
    return tagIcon(tag, {
      className: iconClassName
    }, {
      useColor: false
    });
  }
  return null;
}
app.initializers.add('ziven-custom-tags', () => {
  // TagsPage.tagTileView: 在 li 的 style 上加 --tag-bg-image CSS 变量
  // forum.less 用这个变量渲染背景图 + 60% 黑遮罩
  // 没 bgImageUrl 的 tag 走 vendor 默认 (背景色 var(--tag-bg), 不显示遮罩)
  extend(TagsPage.prototype, 'tagTileView', function (vnode, tag) {
    if (!vnode || !vnode.attrs || !tag) return;
    const bgImageUrl = tag.attribute('bgImageUrl');

    // 合并新 style (保留 vendor 原有的 --tag-bg)
    const existingStyle = vnode.attrs.style || {};
    const newStyle = _objectSpread({}, existingStyle);
    if (bgImageUrl) {
      // 有背景图: 加 CSS 变量 + 加 className 让 .forum.less 60% 黑遮罩显示
      newStyle['--tag-bg-image'] = "url(".concat(bgImageUrl, ")");
      vnode.attrs.className = (vnode.attrs.className || '') + ' ziven-custom-tags-has-bg-image';
    } else {
      // 没背景图: 走 vendor 默认背景色 var(--tag-bg), 不显示 zct 遮罩
      // (不要 set --tag-bg-image, 让 .TagTile 的 background-image: var(--tag-bg-image) 解析为空)
      delete newStyle['--tag-bg-image'];
    }
    vnode.attrs.style = newStyle;
  });

  // v0.1.0l: TagHero.className override — 注入 ziven-custom-tags-header-has-bg-image className
  // forum.less 用这个 className 触发 TagHero 60% 黑遮罩
  // 没 headerBgImageUrl 的 tag 走 vendor 默认 (背景色 var(--hero-bg) = tag color)
  override(TagHero.prototype, 'className', function (original) {
    let className = original() || '';
    if (!this.attrs || !this.attrs.model) return className;
    const headerBgImageUrl = this.attrs.model.attribute('headerBgImageUrl');
    if (headerBgImageUrl) {
      className = (className + ' ziven-custom-tags-header-has-bg-image').trim();
    }
    return className;
  });

  // v0.1.0l: TagHero.style override — 注入 --hero-bg-image CSS 变量
  // vendor Hero less: background: var(--hero-bg), 走 zct background-image: var(--hero-bg-image) 覆盖
  override(TagHero.prototype, 'style', function (original) {
    const style = original() || {};
    if (!this.attrs || !this.attrs.model) return style;
    const headerBgImageUrl = this.attrs.model.attribute('headerBgImageUrl');
    if (headerBgImageUrl) {
      style['--hero-bg-image'] = "url(".concat(headerBgImageUrl, ")");
    }
    return style;
  });

  // v0.1.0m: DiscussionListItem.infoItems extend — 替换 tags item
  // vendor tags 扩展在 infoItems 末尾 add('tags', tagsLabel(tags), 10)
  //   tagsLabel helper 内部用 tagLabel(tag) 渲染每个 tag, tagLabel 内部用 tagIcon(tag, {className:'TagLabel-icon'}, {useColor:false})
  // 我们如果有 tag 有 tagIconUrl, 整个 tags 区域换成 CustomTagsLabel mithril 组件, 内部按 tag 决定 img 还是 FA 图标
  // ziven-core mobile jQuery 重组在 ziven-custom-tags extend 之后执行 onupdate, 会 clone 我们的新 DOM 到 itemFooter, 自动生效
  // v0.1.0n.a (辉哥 9/9 12:14 反馈 "前台还是用帖子背景图, 而不是新加的tag图片图标"):
  //   - 替换判断从 bgImageUrl 改成 tagIconUrl — 9/9 配的科普知识 tag (有 bgImageUrl 没 tagIconUrl)
  //     不再触发 CustomTagsLabel 替换, 走 vendor 原生 tagsLabel (FA icon)
  //   - 内部 CustomTagsLabel 也去掉 bgImageUrl fallback, 只用 tagIconUrl + FA
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs.discussion;
    if (!discussion) return;
    const tags = discussion.tags();
    if (!tags || !tags.length) return;

    // v0.1.0n.a: 用 tagIconUrl 决定是否整段替换, 不用 bgImageUrl (辉哥 12:14 反馈)
    const anyWithImage = tags.some(t => t && t.attribute && t.attribute('tagIconUrl'));
    if (!anyWithImage) return;

    // 移除 vendor tags item (FA 图标版本)
    items.remove('tags');

    // 替换成 CustomTagsLabel mithril 组件 (内部按 tag 决定 img 还是 FA 图标)
    items.add('tags', m(CustomTagsLabel, {
      tags
    }), 10);
  });

  // v0.1.0m: DiscussionHero.items extend — 替换 tags item (同模式, priority 5)
  // vendor tags 扩展: add('tags', tagsLabel(tags, {link: true}), 5) — 用 <Link> 包裹
  // v0.1.0n.a: 同样改 tagIconUrl 决定替换
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    if (!discussion) return;
    const tags = discussion.tags();
    if (!tags || !tags.length) return;
    const anyWithImage = tags.some(t => t && t.attribute && t.attribute('tagIconUrl'));
    if (!anyWithImage) return;
    items.remove('tags');
    items.add('tags', m(CustomTagsLabel, {
      tags,
      link: true
    }), 5);
  });

  // v0.1.0n.b (辉哥 9/9 12:24 反馈 "tag列表页 /t/kpzs 没有按图片图标和 FA 图标逻辑展示"):
  //   TagHero (tag 详情页 hero, h1 标题旁的 icon) + TagLinkButton (sidebar nav + IndexPage 主内容 tag 列表)
  //   之前都没按 tagIconUrl 逻辑, 全部走 vendor tagIcon (FA)
  //   修法: 用 vendor ItemList.setContent(key, content) 替换 item content (官方 API, 跟 add 不一样, 不 skip 同 key)
  //   vendor/flarum/core/js/src/common/utils/ItemList.ts:89 setContent() 替换已有 key 的 content
  extend(TagHero.prototype, 'contentItems', function (items) {
    const tag = this.attrs.model;
    if (!tag) return;

    // 重建 tag-title vnode, 用 renderTagIconPart 替换 vendor tagIcon
    // 保留 Hero-title h1 包装 + tag name
    items.setContent('tag-title', m("h1", {
      className: "Hero-title"
    }, renderTagIconPart(tag), " ", tag.name()));
  });
  extend(TagLinkButton.prototype, 'linkItems', function (items) {
    const tag = this.attrs.model;
    if (!tag) return;

    // setContent 替换 'icon' item, iconClassName 用 'Button-icon' 跟 vendor TagLinkButton 一致
    items.setContent('icon', renderTagIconPart(tag, 'Button-icon'));
  });
});